var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3145",
    filter: "url(#filter0_d_12_24010)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.1685 16.7215C30.8864 16.7215 33.0781 18.9109 33.0781 21.6307C33.0781 24.3489 30.8867 26.5383 28.1685 26.5383C25.4503 26.5383 23.259 24.3493 23.259 21.6307C23.259 18.9113 25.4507 16.7215 28.1685 16.7215ZM8.00655 11.8581H30.5264L30.0034 15.5393C29.4203 15.3655 28.8058 15.267 28.1685 15.267C27.0371 15.267 25.9733 15.5693 25.0519 16.0924V14.6998C25.0584 14.2891 24.7235 13.9549 24.3127 13.9626C23.9124 13.9691 23.5916 14.2991 23.5978 14.6998V17.2161C22.4925 18.3618 21.8072 19.9178 21.8072 21.6307C21.8072 22.4418 21.9653 23.2171 22.246 23.9324H11.1747C10.6421 23.9324 10.2794 23.8043 10.0314 23.604C9.78293 23.4013 9.60679 23.1113 9.53449 22.6044L8.00655 11.8581ZM6.20941 8.2427H32.3208C32.765 8.2427 33.0777 8.55498 33.0777 8.94379V9.70525C33.0777 10.0914 32.765 10.406 32.3208 10.406H6.20941C5.76484 10.406 5.4541 10.0914 5.4541 9.70525V8.94379C5.45448 8.55498 5.76522 8.2427 6.20941 8.2427ZM14.9667 1.45448H23.5636C24.102 1.45448 24.2666 1.5387 24.4793 1.72292C24.6892 1.90867 24.9434 2.29171 25.3261 2.84474L28.0505 6.7886H10.4779L13.2038 2.84474C13.5868 2.29171 13.8414 1.90867 14.0537 1.72292C14.266 1.5387 14.4298 1.45448 14.9667 1.45448ZM14.9667 0.000384735C14.1975 0.000384735 13.5526 0.232671 13.0957 0.631095C12.6411 1.02837 12.3708 1.4964 12.01 2.01904L8.71149 6.7886H6.20941C5.01144 6.7886 4 7.74813 4 8.94379V9.70525C4 10.9009 5.01144 11.8581 6.20941 11.8581H6.53938L8.09424 22.8087C8.20615 23.5978 8.55458 24.2808 9.11337 24.7339C9.67255 25.1865 10.3998 25.3869 11.1743 25.3869H23.0467C24.2062 26.9633 26.0691 27.9928 28.1681 27.9928C31.6732 27.9928 34.5299 25.1338 34.5299 21.6307C34.5299 19.299 33.2619 17.258 31.3832 16.1504L31.9916 11.8577H32.3204C33.518 11.8577 34.5295 10.9005 34.5295 9.70487V8.9434C34.5295 7.74774 33.518 6.78822 32.3204 6.78822H29.8207L26.5214 2.01866C26.1606 1.49602 25.8884 1.0276 25.4338 0.630711C24.9788 0.232286 24.3339 0 23.5632 0H14.9667V0.000384735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.1591 18.6251C27.758 18.6312 27.4396 18.9593 27.4438 19.3604V20.9041H25.9013C25.4967 20.8964 25.1621 21.2245 25.1621 21.6313C25.1621 22.0378 25.4967 22.3647 25.9013 22.3586H27.4438V23.9031C27.4438 24.8726 28.8979 24.8726 28.8979 23.9031V22.3586H30.4428C30.8493 22.3647 31.1816 22.0382 31.1816 21.6313C31.1816 21.2245 30.8493 20.8964 30.4428 20.9041H28.8979V19.3604C28.9018 18.9516 28.5691 18.6189 28.1591 18.6251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.1959 13.9611C13.7951 13.9676 13.4748 14.2976 13.4805 14.6983V20.8735C13.4748 21.2781 13.8009 21.6107 14.2078 21.6107C14.6131 21.6107 14.9393 21.2781 14.9335 20.8735V14.6987C14.9412 14.2879 14.6062 13.9537 14.1959 13.9611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.2544 13.9611C18.8518 13.9676 18.5314 14.2976 18.5372 14.6983V20.8735C18.5333 21.2781 18.8598 21.6107 19.2644 21.6107C19.6713 21.6107 19.997 21.2781 19.9917 20.8735V14.6987C19.9974 14.2879 19.6632 13.9537 19.2544 13.9611Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12_24010",
    x: 0,
    y: 0,
    width: 38.5303,
    height: 35.9928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_24010"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_24010",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddProducts);
export default __webpack_public_path__ + "static/media/icon-add-products.09e36aa65216d4e53cbf164823c29b4c.svg";
export { ForwardRef as ReactComponent };